const normalizeLabel = value =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

const SYSTEM_TAG_NAMES = new Set(['excluded', 'ai agent']);
const SPECIAL_TAG_TOKENS = new Map([
  ['qa', 'QA'],
  ['ai', 'AI'],
  ['ai/ml', 'AI/ML'],
  ['devops', 'DevOps'],
  ['on-site', 'On-site']
]);

export const canonicalizeTagName = value =>
  String(value || '')
    .normalize('NFKC')
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map(token => {
      const lower = token.toLocaleLowerCase('en-US');
      if (SPECIAL_TAG_TOKENS.has(lower)) return SPECIAL_TAG_TOKENS.get(lower);
      return lower.replace(
        /(^|[-/])([a-z])/g,
        (_match, prefix, letter) =>
          `${prefix}${letter.toLocaleUpperCase('en-US')}`
      );
    })
    .join(' ');

export const getProjectEntries = projects => {
  if (Array.isArray(projects)) {
    return projects.filter(Boolean);
  }

  if (projects && typeof projects === 'object') {
    return Object.values(projects).filter(Boolean);
  }

  return [];
};

export const isDefaultProject = project =>
  normalizeLabel(project?.name) === 'default';

export const getCustomProjects = projects =>
  getProjectEntries(projects).filter(project => !isDefaultProject(project));

export const hasNoCustomProjects = projects =>
  getCustomProjects(projects).length === 0;

export const isSystemTag = tag =>
  SYSTEM_TAG_NAMES.has(normalizeLabel(tag?.tagName || tag?.name || tag));

export const getCustomTags = tags =>
  (Array.isArray(tags) ? tags : []).filter(tag => !isSystemTag(tag));

export const hasNoCustomTags = tags => getCustomTags(tags).length === 0;
